import type { IFilterValueType } from '@/types/sections.type'

import { request } from '@/utils/request'

export interface DataRequest {
  Actions: {
    Action: string
    Items: unknown[]
  }
  BundleType: string
  Filter: IFilterValueType[]
  Pager: {
    Page: number
    RecsOnPage: number
  }
  Sort: Array<{ Name: string, Title: string, Type: string }>
  ViewName: string
}

export class EmptyDataProvider {
  static getEmptyData (): DataRequest {
    return {
      Actions: {
        Action: '',
        Items: []
      },
      BundleType: '',
      Filter: [],
      Pager: {
        Page: 1,
        RecsOnPage: 10
      },
      Sort: [],
      ViewName: ''
    }
  }

  getData (): DataRequest {
    return EmptyDataProvider.getEmptyData()
  }
}

export const postData = <T = any>(body: DataRequest) => {
  return request<T>('/api/views/data', {
    method: 'POST',
    body: JSON.stringify(body)
  })
}

export const setDataExport = (body: DataRequest) => {
  return request('/api/views/data/export', {
    method: 'POST',
    body: JSON.stringify(body)
  })
}

export const nodeExport = (body: unknown) => {
  return fetch('/api/node/export', {
    method: 'POST',
    body: JSON.stringify(body)
  })
    .then((response) => response.json())
    .then((response) => response)
}
